(function () {
  angular.module('MktzapApp.Factories')
    .factory('ContactMetadataDefinitionService', ContactMetadataDefinitionService);

  ContactMetadataDefinitionService.$inject = ['$resource'];

  function ContactMetadataDefinitionService ($resource) {
    return $resource('', {}, {
      all: { url: apiUrl + '/all-cmd', method: 'GET', isArray: true },
      create: { url: apiUrl + '/create-cmd', method: 'POST', isArray: false },
      update: { url: apiUrl + '/update-cmd', method: 'POST', isArray: false },
      find: { url: apiUrl + '/find-cmd', method: 'GET', isArray: false }
    });
  }
})();
